<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Company" tabActive="Vision" bg="/images/sub/visual/sv-company.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <div class="tit-wrap text-center">
                <h3 class="tit tit--lg">Vision</h3>
            </div>

            <div class="w-100" data-aos="fade-up">
                <v-img contain max-width="1080" class="d-none d-md-block ma-auto" src="/images/sub/company/vision-img-ko.png" />
                <v-img contain max-width="672" class="d-block d-md-none ma-auto" src="/images/sub/company/vision-img-mo-ko.png" />
            </div>
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
    },
};
</script>

<style lang="scss" scoped></style>
